import { accessCode } from "./all";

export const LIST_URL_WAREHOUSE = {
  // ====================================== MasterWMS ====================================== \\
  masterGudang: {
    getGudang: "/wmsmaster/gudang/read",
    add: "/wmsmaster/gudang/create",
    delete: "/wmsmaster/gudang/delete",
    getGudangUnit: "/wmsmaster/unit/read_gudang_farmasi",
    update: "/wmsmaster/gudang/update",
  },
  masterProdusen: {
    get: "/wmsmaster/produsen/read",
    add: "/wmsmaster/produsen/create",
    update: "/wmsmaster/produsen/update",
    delete: "/wmsmaster/produsen/delete",
  },
  masterSatuan: {
    get: "/wmsmaster/satuan/read",
    add: "/wmsmaster/satuan/create",
    update: "/wmsmaster/satuan/update",
    delete: "/wmsmaster/satuan/delete",
  },
  masterSupplier: {
    get: "/wmsmaster/supplier/read",
    add: "/wmsmaster/supplier/create",
    update: "/wmsmaster/supplier/update",
    delete: "/wmsmaster/supplier/delete",
    getByPo: "/wmsmaster/supplier/read_po_farmasi",
  },
  masterTarifCbg: {
    get: "/wmsfarmasi/master/tarifCbg/list",
    add: "/wmsfarmasi/master/tarifCbg/register",
    update: "/wmsfarmasi/master/tarifCbg/update",
    delete: "/wmsfarmasi/master/tarifCbg/delete",
  },
  masterUnit: {
    get: "/wmsfarmasi/master/masterUnit/list",
    add: "/wmsfarmasi/master/masterUnit/create",
    update: "/wmsfarmasi/master/masterUnit/update",
    delete: "/wmsfarmasi/master/masterUnit/delete",
  },

  // ====================================== Perbekalan Farmasi ====================================== \\
  masterBarangPBF: {
    get: "/wmsfarmasi/master/masterBarang/list",
    getWithTarif: "/wmsfarmasi/master/masterBarang/list-barang-with-tarif",
    add: "/wmsfarmasi/master/masterBarang/register",
    update: "/wmsfarmasi/master/masterBarang/update",
    updateHPP: "/wmsfarmasi/master/masterBarang/update-harga",
    delete: "/wmsfarmasi/master/masterBarang/delete",
    getById: "/wmsfarmasi/master/masterBarang/detailsById",
    byKelasTerpiId: "/wmsfarmasi/master/masterBarang/listBarangByKelasTerapiId",
    getWithTarifExport:
      "/wmsfarmasi/master/masterBarang/list-barang-with-tarif-export",
  },
  masterKelasTerapiPBF: {
    get: "/wmsfarmasi/master/kelasTerapi/list",
    getAll: "/wmsfarmasi/master/kelasTerapi/read",
    add: "/wmsfarmasi/master/kelasTerapi/register",
    update: "/wmsfarmasi/master/kelasTerapi/update",
    delete: "/wmsfarmasi/master/kelasTerapi/delete",
  },
  masterProdusenPBF: {
    get: "/wmsmaster/produsen/read_barang_farmasi",
  },
  masterJenisObatPBF: {
    get: "/wmsfarmasi/master/jenisObat/list",
    getAll: "/wmsfarmasi/master/jenisObat/read",
    add: "/wmsfarmasi/master/jenisObat/register",
    update: "/wmsfarmasi/master/jenisObat/update",
    delete: "/wmsfarmasi/master/jenisObat/delete",
  },
  masterGolonganObatPBF: {
    get: "/wmsfarmasi/master/golonganBarang/list",
    getAll: "/wmsfarmasi/master/golObat/read",
    add: "/wmsfarmasi/master/golonganBarang/register",
    update: "/wmsfarmasi/master/golonganBarang/update",
    delete: "/wmsfarmasi/master/golonganBarang/delete",
  },
  masterHarga: {
    get: "/wmsfarmasi/master/harga/list",
    add: "/wmsfarmasi/master/harga/register",
    update: "/wmsfarmasi/master/harga/update",
    delete: "/wmsfarmasi/master/harga/delete",
  },
  masterHargaFormula: {
    get: "/wmsfarmasi/master/formulaHarga/list",
    update: "/wmsfarmasi/master/formulaHarga/update",
  },
  masterFormula: {
    get: "/wmsfarmasi/master/formula/list",
    add: "/wmsfarmasi/master/formula/register",
    update: "/wmsfarmasi/master/formula/update",
    delete: "/wmsfarmasi/master/formula/delete",
  },
  masterGudangPBF: {
    get: "/wmsfarmasi/gudang/listfarmasi",
    getGudang: `/wmsfarmasi/gudang/list?access_code=${accessCode.gudang_farmasi}`,
    getGudanngTujuan: `/wmsfarmasi/gudang/list?access_code=${accessCode.gudang_farmasi}`,
    getGudanngSumber: `/wmsfarmasi/gudang/list`,
    getGudangUtama: `/wmsfarmasi/gudang/gudangutama?access_code=${accessCode.gudang_farmasi}`,
    add: "/wmsfarmasi/gudang/register",
    update: "/wmsfarmasi/gudang/update",
    delete: "/wmsfarmasi/gudang/delete",
    gudangOnlyFarmasi: "/wmsfarmasi/master/gudang/utamaFarmasi/read_po",
    download: "/wmsfarmasi/gudang/listItemTransferByMutasiId-pdf",
  },

  // ====================================== Infentory Control PBF ====================================== \\
  daftarAdjustmentPBF: {
    get: "/wmsfarmasi/adjustment/list",
    delete: "/wmsfarmasi/adjustment/delete",
  },
  daftarInventoryControl: {
    get: "/wmsfarmasi/inventory/list",
    delete: "/wmsfarmasi/inventory/delete",
    barangByGudang: "/wmsfarmasi/inventory/listBarangByGudangId",
    barangNotinGudang:
      "/wmsfarmasi/inventory/list-barang-not-in-inventory-bygudang",
  },
  daftarMutasi: {
    get: "/wmsfarmasi/gudang/listParentMutasi",
    delete: "/wmsfarmasi/gudang/deleteMutasi",
  },
  daftarStokOpname: {
    get: "/wmsfarmasi/stockOpname/listAllStockOpname",
    delete: "/wmsfarmasi/stockOpname/delete",
    download: "/wmsfarmasi/stockOpname/downloadStockOpname"
  },
  inputAdjustment: {
    get: "/wmsfarmasi/adjustment/register",
    add: "/wmsfarmasi/adjustmentList/register",
    addUnit: "/wmsfarmasi/adjustmentList/register-unit",
    update: "/wmsfarmasi/adjustmentList/update",
    updateUnit: "/wmsfarmasi/adjustmentList/update-unit",
    delete: "/wmsfarmasi/adjustmentList/delete",
    process: "/wmsfarmasi/adjustment/prosesAdjustment",
    barangByAdjustment: "/wmsfarmasi/adjustmentList/listBarangByAdjustmenId",
  },

  mutasiItemPBF: {
    add: "/wmsfarmasi/gudang/requestItemMutasiGudang",
    update: "/wmsfarmasi/gudang/updateRequestItem",
    delete: "/wmsfarmasi/gudang/deleteItem",
    process: "/wmsfarmasi/gudang/ACCEPTmutasiGudang",
    get: "/wmsfarmasi/gudang/listItemTransferByMutasiId",
    addMutasi: "/wmsfarmasi/gudang/requestMutasiGudang",
    updateMutasi: "/wmsfarmasi/gudang/updateRequestMutasiGudang",
    batalMutasi: "/wmsfarmasi/gudang/batalkan-request-mutasi",
    tolakMutasi: "/wmsfarmasi/gudang/tolak-request-mutasi",
  },
  stockOpnamePBF: {
    getById: "/wmsfarmasi/stockOpname/listItemByStockOpnameId",
    add: "/wmsfarmasi/stockOpname/registerStockOpname",
    upload: "/wmsfarmasi/stockOpname/uploadStockOpname",
    accept: "/wmsfarmasi/stockOpname/acceptStockOpname",
  },
  trackingNarkotikPBF: {
    get: "/wmsfarmasi/inventory/trackingNarkotik",
  },
  receiveMutasiPBF: {},

  // ====================================== Laporan Perbekala Farmasi ====================================== \\
  historyStokPBF: {
    get: "/wmsfarmasi/inventory/lap-history-stok",
    export: "/wmsfarmasi/inventory/lap-history-stok-export",
  },
  kartuStokPBF: {
    get: "/wmslogistik/",
    export: "/Export",
  },
  laporanNarkotik: {
    get: "/wmsfarmasi/narkotik/list",
    export: "/wmsfarmasi/narkotik/list",
    exportAll: "exportall-narkotik",
  },

  // ====================================== Transaksi Gudang Utama Perbekalan Farmasi ====================================== \\
  PembayaranPBF: {
    get: "/wmsfarmasi/pembayaran_pembelian/listAll",
    getById: "/wmsfarmasi/pembayaran_pembelian/listByPembelianId",
    add: "/wmsfarmasi/pembayaran_pembelian/register",
    delete: "/wmsfarmasi/pembayaran_pembelian/delete",
  },
  pembelianPBF: {
    get: "/wmsfarmasi/pembelian/list",
    getById: "/wmsfarmasi/pembelian/detailsById",
    getItemById: "/wmsfarmasi/pembelianItem/listItemByPembelianId",
    export: "/wmsfarmasi/pembelian/list-export",
    total: "/wmsfarmasi/pembelian/listTotalPembelian",
    add: "/wmsfarmasi/pembelian/register",
    update: "/wmsfarmasi/pembelian/update",
    delete: "/wmsfarmasi/pembelian/delete",
    accept: "/wmsfarmasi/inventory/acceptPembelianCekHPP",

    addBarang: "/wmsfarmasi/pembelianItem/registerTanpaPO",
    updateBarang: "/wmsfarmasi/pembelianItem/update",
    deleteBarang: "/wmsfarmasi/pembelianItem/delete",

    close: "/wmsfarmasi/pembelian/closePembelian",
  },
  purchaseOrderPBF: {
    get: "/wmsfarmasi/PO/list",
    getByPo: "/wmsfarmasi/PO/detailsById",
    add: "/wmsfarmasi/PO/register",
    update: "/wmsfarmasi/PO/update",
    delete: "/wmsfarmasi/PO/delete",

    getBarangPo: "/wmsfarmasi/POList/listBarangByPoId",
    addBarang: "/wmsfarmasi/POList/register",
    deleteBarang: "/wmsfarmasi/POList/delete/",
    updateBarang: "/wmsfarmasi/POList/update",
    changeStatus: "/wmsfarmasi/PO/changeStatus",
  },
  returPembelianPBF: {
    get: "/wmsfarmasi/retur_pembelian/list",
    getListId: "/wmsfarmasi/retur_pembelian/listItems_by_returPembelianId",
    getById: "/wmsfarmasi/retur_pembelian/listItemByPembelianIdReturn",
    add: "/wmsfarmasi/retur_pembelian/register",
    update: "/wmsfarmasi/retur_pembelian/update",
    addItem: "/wmsfarmasi/retur_pembelian/register_items",
    updateItem: "/wmsfarmasi/retur_pembelian/update_items",
    process: "/wmsfarmasi/retur_pembelian/process",
    deleteItem: "/wmsfarmasi/retur_pembelian/delete_items",
    deleteRetur: "/wmsfarmasi/retur_pembelian/deleteProfil",
  },
  serviceTutupPembelian: {
    get: "/wmsfarmasi/pelunasan_excel/list",
    add: "/wmsfarmasi/pelunasan_excel/register",
    process: "/wmsfarmasi/pembayaran_pembelian/submitPelunasanExcel",
    delete: "/wmsfarmasi/pelunasan_excel/delete",
  },

  // ====================================== MASTER LOGISTIK ====================================== \\
  masterBarangLGS: {
    get: "/wmsMasterLogistik/master_barang/list",
    getById: "/wmsMasterLogistik/master_barang/list_id",
    add: "/wmsMasterLogistik/master_barang/add",
    update: "/wmsMasterLogistik/master_barang/update",
    delete: "/wmsMasterLogistik/master_barang/delete",
    upload: "/wmsMasterLogistik/master_barang/upload",
    download: "/wmsMasterLogistik/master_barang/download_template",
  },
  masterProdusenLGS: {
    get: "/wmsMasterLogistik/get_masterb/produsen",
  },
  masterSatuanLGS: {
    get: "/wmsMasterLogistik/get_masterb/satuan",
  },
  masterSuppilerLGS: {
    get: "/wmsMasterLogistik/get_masterb/supiler",
  },
  masterGolBarangLGS: {
    get: "/wmsMasterLogistik/master_golongan/list",
    getById: "/wmsMasterLogistik/master_golongan/list_id",
    add: "/wmsMasterLogistik/master_golongan/add",
    update: "/wmsMasterLogistik/master_golongan/update",
    delete: "/wmsMasterLogistik/master_golongan/delete",
  },
  masterGudangLGS: {
    getAllUtama: "/wmslogistik/gudang/list",
    get: `/wmslogistik/gudang/listlogistik?access_code=${accessCode.gudang_logistik}`, // ini buat list guadng di master gudang
    getUtama: `/wmslogistik/gudang/list?access_code=${accessCode.gudang_logistik}`,
    getGudangUtama: `/wmslogistik/gudang/gudangutama?access_code=${accessCode.gudang_logistik}`,

    getGudangSumber: `/wmslogistik/gudang/list`,
    getGudangTujuan: `/wmslogistik/gudang/list?access_code=${accessCode.gudang_logistik}`,

    add: "/wmslogistik/gudang/register",
    update: "/wmslogistik/gudang/update",
    delete: "/wmslogistik/gudang/delete",
    download: "/wmslogistik/gudang/download_pdf",
    InitialLGS: "/wmslogistik/master/gudang/utamaFarmasi/read_po",
  },
  masterJenisBarangLGS: {
    get: "/wmslogistik/master/jenisBarang/read",
    add: "/wmslogistik/master/jenisBarang/create",
    update: "/wmslogistik/master/jenisBarang/update",
    delete: "/wmslogistik/master/jenisBarang/delete",
  },
  statusPengeluaranBarangLGS: {
    get: "/wmslogistik/master/statuspengeluaranbarang/list",
    add: "/wmslogistik/master/statuspengeluaranbarang/register",
    update: "/wmslogistik/master/statuspengeluaranbarang/update",
    delete: "/wmslogistik/master/statuspengeluaranbarang/delete",
  },

  // ====================================== INVENTORY CONTROL LOGISTIK ====================================== \\
  adjustmentLGS: {
    get: "/wmslogistik/adjustment/list",
    add: "/wmslogistik/adjustment/register",
    delete: "/wmslogistik/adjustment/delete",
    addBarang: "/wmslogistik/adjustmentList/register",
    updateBarang: "/wmslogistik/adjustmentList/update",
    deleteBarang: "/wmslogistik/adjustmentList/delete",
    process: "/wmslogistik/adjustment/proses-pemakaian",
  },
  adjustLGS: {
    get: "/wmslogistik/adjust/list",
    add: "/wmslogistik/adjust/register",
    delete: "/wmslogistik/adjust/delete",
    addBarang: "/wmslogistik/adjustList/register",
    updateBarang: "/wmslogistik/adjustList/update",
    deleteBarang: "/wmslogistik/adjustList/delete",
    process: "/wmslogistik/adjust/prosesAdjustment",
    barangByAdjustment: "/wmslogistik/adjustList/listBarangByAdjustmenId",
  },
  inventoryControlLGS: {
    get: "/wmslogistik/inventory/list",
    delete: "/wmslogistik/inventory/delete",
    bulk: "/wmslogistik/inventory/bulk-register",
    barangNotinGudang:
      "wmslogistik/inventory/list-barang-not-in-inventory-bygudang",
    getBarangByGudang: "/wmslogistik/inventory/listBarangByGudangId",
    getBarangByAdjustment:
      "/wmslogistik/adjustmentList/listBarangByAdjustmenId",
    getBarangByGudangTujuan:
      "/wmslogistik/inventory/listBarangByGudangIdTujuan",
    getBarangByMutasi: "/wmslogistik/gudang/listItemTransferByMutasiId",
    getStokById: "/wmslogistik/inventory/get-stock-by-id",
    getLaporanStok: "/wmslogistik/inventory/lap-inventory-stok",
  },
  mutasiItemLGS: {
    get: "/wmslogistik/gudang/listParentMutasi",
    add: "/wmslogistik/gudang/requestMutasiGudang",
    update: "/wmslogistik/gudang/updateRequestMutasiGudang",
    processMutasi: "/wmslogistik/gudang/mutasiGudang",
    delete: "/wmslogistik/gudang/deleteMutasi",
    process: "/wmslogistik/gudang/ACCEPTmutasiGudang",
    addBarang: "/wmslogistik/gudang/requestItemMutasiGudang",
    updateBarang: "/wmslogistik/gudang/updateRequestItem",
    deleteBarang: "/wmslogistik/gudang/deleteItem",
  },
  stockOpnameLGS: {
    getById: "/wmslogistik/stockOpname/listItemByStockOpnameId",
    add: "/wmslogistik/stockOpname/registerStockOpname",
    upload: "/wmslogistik/stockOpname/uploadStockOpname",
    accept: "/wmslogistik/stockOpname/acceptStockOpname",
  },
  daftarStokOpnameLGS: {
    get: "/wmslogistik/stockOpname/listAllStockOpname",
    delete: "/wmslogistik/stockOpname/delete",
    download: "/wmslogistik/stockOpname/downloadStockOpname",
  },

  // ====================================== TRANSAKSI GUDANG UTAMA LOGISTIK ====================================== \\
  pembayaranLGS: {
    get: "/wmslogistik/pembayaran_pembelian/listAll",
    getById: "/wmslogistik/pembayaran_pembelian/listByPembelianId",
    add: "/wmslogistik/pembayaran_pembelian/register",
    delete: "/wmslogistik/pembayaran_pembelian/delete",
  },
  pembelianLGS: {
    get: "/wmslogistik/pembelian/list",
    export: "/wmslogistik/pembelian/list-export",
    getById: "/wmslogistik/pembelian/detailsById",
    add: "/wmslogistik/pembelian/register",
    update: "/wmslogistik/pembelian/update",
    accept: "/wmslogistik/inventory/acceptPembelianCekHPP",
    getBarangById: "wmslogistik/pembelianItem/listItemByPembelianId",
    addBarang: "/wmslogistik/pembelianItem/registerTanpaPO",
    updateBarang: "/wmslogistik/pembelianItem/update",
    deleteBarang: "/wmslogistik/pembelianItem/delete",
    delete: "/wmslogistik/pembelian/delete",
    total: "/wmslogistik/pembelian/listTotalPembelian",
  },
  purchaseOrderLGS: {
    get: "/wmsPoLogistik/po/list",
    getById: "/wmsPoLogistik/po/list_id",
    add: "/wmsPoLogistik/po/add",
    update: "/wmsPoLogistik/po/update",
    delete: "/wmsPoLogistik/po/delete",

    getBarangByPO: "/wmsPoLogistik/po/list_id",
    changeStatus: "/wmsPoLogistik/po/update_transaksi",
    download: "/wmsPoLogistik/po/download_pdf",
  },
  returPembelianLGS: {
    get: "/wmslogistik/retur_pembelian/list",
    add: "/wmslogistik/retur_pembelian/register",
    update: "/wmslogistik/retur_pembelian/update",
    delete: "/wmslogistik/retur_pembelian/deleteProfil",
    addBarang: "/wmslogistik/retur_pembelian/register_items",
    updateBarang: "/wmslogistik/retur_pembelian/update_items",
    deleteBarang: "/wmslogistik/retur_pembelian/delete_items",
    getBarangPembelian:
      "/wmslogistik/retur_pembelian/listItemByPembelianIdReturn",
    getBarangRetur:
      "/wmslogistik/retur_pembelian/listItems_by_returPembelianId",
  },
  serviceTutupPembelianLGS: {
    get: "/wmslogistik/pelunasan_excel/list",
    add: "/wmslogistik/pelunasan_excel/register",
    delete: "/wmslogistik/pelunasan_excel/delete",
    process: "/wmslogistik/pembayaran_pembelian/submitPelunasanExcel",
  },

  // ====================================== LAPORAN LOGISTIK ====================================== \\
  historyStokLGS: {
    get: "/wmslogistik/inventory/lap-history-stok",
    export: "/wmslogistik/inventory/lap-history-stok-export",
  },
  kartuStokLGS: {
    get: "/wmslogistik/inventory/lap-kartu-stok",
    export: "/wmslogistik/inventory/lap-kartu-stok-export",
  },
  laporanStokLGS: {
    export: "/wmslogistik/inventory/lap-inventory-stok-export",
  },
};
